/**
 * Rupa satu baris tugas — MURNI.
 *
 * Bentuknya diambil dari desain 22 Agu: lingkaran penanda, judul, label kecil, dan pil status di
 * kanan. SATU hal sengaja tidak disalin — di desain lingkaran itu KOTAK CENTANG yang diketuk
 * untuk menyelesaikan tugas. Di sini tugas tidak diselesaikan dari daftar: ia punya alur sendiri
 * (Terima → Mulai → Tiba → Selesai) yang menuntut lokasi dan bukti.
 *
 * Karena itu lingkaran di sini adalah PENANDA, bukan kontrol, dan seluruh barisnya satu tautan ke
 * detail. Lingkaran yang tampak seperti kotak centang tetapi tidak dapat dicentang adalah janji
 * yang tidak ditepati — dan pada layar yang dipakai sambil berdiri, satu ketukan yang tidak
 * menghasilkan apa pun sudah cukup membuat orang berhenti mempercayai penandanya.
 */

export type TaskMark = 'selesai' | 'gagal' | 'batal' | 'berjalan' | 'menunggu';

/**
 * Nada penanda untuk sebuah status.
 *
 * Status yang TIDAK dikenal jatuh ke `menunggu`, bukan dilempar: status baru dapat lahir di
 * server lebih dulu daripada di layar ini, dan baris yang hilang karena status barunya belum
 * dikenal jauh lebih buruk daripada baris yang penandanya kurang tepat.
 */
export function taskMark(status: string): TaskMark {
  switch (status) {
    case 'completed':
      return 'selesai';
    case 'failed':
      return 'gagal';
    case 'cancelled':
      return 'batal';
    case 'accepted':
    case 'started':
    case 'arrived':
      return 'berjalan';
    default:
      return 'menunggu';
  }
}

/**
 * Judul dicoret HANYA untuk tugas yang benar-benar tuntas.
 *
 * `failed` dan `cancelled` TIDAK dicoret meski sama-sama berakhir. Coretan terbaca sebagai
 * "beres, tidak perlu dilihat lagi" — padahal tugas gagal justru yang paling perlu dibuka:
 * seseorang harus memutuskan mengulang atau tidak.
 */
export function taskStruck(status: string): boolean {
  return status === 'completed';
}
